import React, { useState, useEffect } from 'react';
import { getImageUrl } from '../../../utils/image';
import './ScannedItemsList.css';

const ShirtIcon = () => (
  <svg width="40" height="40" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="56" height="56" rx="8" fill="#F3F4F6"/>
    <path d="M36 14L44 22L38 24V42H18V24L12 22L20 14C20 14 22 18 28 18C34 18 36 14 36 14Z"
          stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ScannedItem = ({item}) =>
{
  const [imageUrl, setImageUrl] = useState(null);
  const [imageLoading, setImageLoading] = useState(true);

  useEffect(() =>
  {
    const fetchImageUrl = async () =>
    {
      if (item?.style && item?.colorCode)
      {
        try
        {
          const url = await getImageUrl(item.style, item.colorCode, 300, 300);
          setImageUrl(url);
        } catch (error)
        {
          console.error('Error loading image:', error);
        } finally
        {
          setImageLoading(false);
        }
      } else
      {
        setImageLoading(false);
      }
    };

    fetchImageUrl();
  }, [item?.style, item?.colorCode]);

  return (
    <div className="scanned-item">
      <div className="scanned-item-image">
        {imageLoading ? (
          <div className="scanned-item-image-placeholder">
            <div className="image-loader"></div>
          </div>
        ) : imageUrl ? (
          <img src={imageUrl} alt={item.itemDesc || item.itemId}/>
        ) : (
          <div className="scanned-item-image-placeholder">
            <ShirtIcon/>
          </div>
        )}
      </div>
      <div className="scanned-item-details">
        <div className="scanned-item-code">{item.itemId}</div>
        <div className="scanned-item-barcode">Barcode: {item.barcode || '—'}</div>
        <div className="scanned-item-info">
          {item.itemDesc || '—'} | Size: {item.sizeDesc || '—'} | Color: {item.colorDesc || item.colorCode || '—'}
        </div>
        <div className="scanned-item-quantity">Quantity: <strong>{item.quantity || '—'}</strong></div>
      </div>
    </div>
  );
};

export const ScannedItemsList = ({scannedItems}) =>
{
  if (!scannedItems || scannedItems.length === 0)
  {
    return (
      <div className="scanned-items-empty">
        <p>No items scanned in this session</p>
      </div>
    );
  }

  return (
    <div className="scanned-items-container">
      <div className="scanned-items-grid">
        {scannedItems.map((item, index) => (
          <ScannedItem key={item.itemId || item.barcode || index} item={item}/>
        ))}
      </div>
    </div>
  );
};
